// Components
import Checkbox from 'components/form/checkbox';
import { DateTime } from 'luxon';
// Modules
import { DI } from 'modules';
import * as React from 'react';
// Constants
import { BRANDING_TYPE } from '../../constants';
import Restricted from './components/restricted';


const DSAgreementOneOff = ({
  agreement,
  common,
  entity,
  form,
  price
}) => {
  const {can} = agreement.can_download_content;
  const {branding_type} = form;

  const {strings} = common;

  const buyPlanCln = 'side-buy-plan';
  const prefix = 'page.video.slider';

  return !can ? (
    <Restricted entity={entity} />
  ) : (
    <>
      {agreement.branding_type === BRANDING_TYPE.ANY && (
        <div className={`${buyPlanCln}__branded`}>
          <Checkbox
            checked={branding_type === BRANDING_TYPE.BRANDED}
            disabled={+form.agreement_id !== +agreement.id}
            name='branding_type'
            uncheckedValue='clean'
            value='branded'
          >
            {`${strings[`${prefix}.branded`]} `}
            <span className={`${buyPlanCln}__discount`}>
              {strings[`${prefix}.save50%`]}
            </span>
          </Checkbox>
        </div>
      )}

      <div className={`${buyPlanCln}__text`}>{`€ ${price} ${
        strings[`${prefix}.one_off.per_item`]
      }`}</div>

      <div className='side-buy-plan__info side-buy-plan__info--padded'>
        {strings[`${prefix}.one_off.rights`]}
        <br />
        {strings[`${prefix}.one_off.valid_till`]}
        {DateTime.local().plus({days: 7}).toUTC().toFormat(strings[`${prefix}.date.format`])}
      </div>
    </>
  );
};

export default DI(['common'])(DSAgreementOneOff);
